export type MessageType = 'email-body' | 'email-subject' | 'sms-body' | 'teams-body' | 'slack-body';


export const MessageKeys: MessageType[] = [
  'email-body',
  'email-subject',
  'sms-body',
  'teams-body',
  'slack-body'
];
